import './assets/tailwind.css'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { registerPiniaPlugins } from './plugins/piniaStore.js'
import App from './App.vue'
import router from './router/index'
import { VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { i18n } from './i18n'
import './assets/nprogress.css'
import NProgress from 'nprogress'
import moment from 'moment'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import vTrack from './directives/v-track'
import { recordError, recording, sendSessionReplay } from './services/tracking-sessions'
import { record } from 'rrweb'

moment.locale('ar-kw')

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false
      }
    }
  }
}

moment.updateLocale('ar-kw', {
  week: {
    dow: 0, // Set Sunday as the first day of the week (0 = Sunday, 1 = Monday, etc.)
    doy: 6 // First week of year must contain Jan 1st (otherwise, the week starts before that)
  }
})

NProgress.configure({ showSpinner: false })
const app = createApp(App)
registerPiniaPlugins(app)

app
  .use(createPinia())
  .use(VueQueryPlugin, vueQueryPluginOptions)
  .use(i18n)
  .use(router)
  .use(Toast, {
    rtl: true
  })
  .use(autoAnimatePlugin)

app.directive('track', vTrack)

app.config.errorHandler = async (err, vm, info) => {
  if (!router.currentRoute.value.fullPath.startsWith('admin') && recording) {
    try {
      recordError(err)
      await sendSessionReplay()
    } catch (error) {}
  }
}
app.mount('#app')
